import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { CorporateService } from '../corporate-service/corporate-service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-fundingsource-configuration',
  templateUrl: './fundingsource-configuration.component.html',
  styleUrls: ['./fundingsource-configuration.component.css']
})
export class FundingsourceConfigurationComponent implements OnInit {

  fundingSourceConfigurationForm: FormGroup;
  fundingSourceList = [];
  filteredFundingSourceList = [];
  status = 'active';
  submitted = false;
  passwordType = 'password';
  passwordToggleFlag = true;
  fundingSourceConfigurationId;

  constructor(
    private fb: FormBuilder,
    private corporateService: CorporateService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    if (
      this.activatedRoute.snapshot.url.length === 5 &&
      this.activatedRoute.snapshot.url[4].path === 'edit'
    ) {
      this.fundingSourceConfigurationId = this.activatedRoute.snapshot.url[3].path;
    }

    this.fundingSourceConfigurationForm = this.fb.group({
      cooperate: ['', Validators.required],
      email: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],
      url: ['', Validators.required],
    });

    this.makeCompulsoryCalls();
  }

  get form() {
    return this.fundingSourceConfigurationForm.controls;
  }

  makeCompulsoryCalls() {
    forkJoin([this.getCorporateUsers()]).subscribe(
      ([res1]) => {
        if (res1) {
          this.fundingSourceList = res1;
          this.filteredFundingSourceList = this.fundingSourceList;
          this.getFundingSourceConfigurations();
        }
      },
      (error) => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getCorporateUsers() {
    return this.corporateService.getCorporateUsers(this.status);
  }

  getFundingSourceConfigurations() {
    this.corporateService
      .getFundingSourceConfigurations()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          const usedFundingSources = data.map(item => item.cooperate);
          if (this.fundingSourceConfigurationId) {
            this.getFundingSourceConfigurationById();
          } else {
            this.filteredFundingSourceList = this.fundingSourceList.filter(
              item => !usedFundingSources.some(_id => item._id === _id)
            );
          }
        }
      });
  }

  getFundingSourceConfigurationById() {
    this.corporateService
      .getFundingSourceConfigurationById(this.fundingSourceConfigurationId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.filteredFundingSourceList = this.fundingSourceList.filter(item => item._id === data.cooperate);
            this.fundingSourceConfigurationForm.patchValue({
              cooperate: data.cooperate,
              email: data.email,
              password: data.password,
              url: data.url,
            });
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  togglePasswordType() {
    this.passwordType = this.passwordToggleFlag ? 'text' : 'password';
    this.passwordToggleFlag = !this.passwordToggleFlag;
  }

  onSubmit() {
    this.submitted = true;
    if (this.fundingSourceConfigurationForm.invalid) {
      return;
    }

    const payload = { ...this.fundingSourceConfigurationForm.value };

    this.corporateService
      .addFundingSourceConfiguration(payload, this.fundingSourceConfigurationId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.router.navigate(['/credentialing/fundingsource'], {
              state: { isFundingSourceConfiguration: true },
            });
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  ngOnDestroy(): void { }

}
